import React from 'react';
import './Process.css';
import { FiSearch, FiPenTool, FiCode, FiSend } from 'react-icons/fi';

const steps = [
  {
    n: '01',
    icon: <FiSearch />,
    title: 'Discover',
    desc: 'We start with the problem, not the technology. A discovery call, a clear scope, and a written plan you can sign off on.',
  },
  {
    n: '02',
    icon: <FiPenTool />,
    title: 'Design',
    desc: 'Wireframes, then high-fidelity mockups. We pressure-test flows in Figma so we never build the wrong thing in code.',
  },
  {
    n: '03',
    icon: <FiCode />,
    title: 'Build',
    desc: 'Two-week sprints. You see real progress in a staging environment every week — not a 3-month silence followed by surprise.',
  },
  {
    n: '04',
    icon: <FiSend />,
    title: 'Ship & Support',
    desc: 'We deploy, monitor, and stay involved. Bug fixes, small features, and v2 planning — without restarting the relationship.',
  },
];

const Process = () => {
  return (
    <section id="process" className="process section section--alt">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">How we work</span>
          <h2 className="section-title section-title--center">
            A process designed for trust.
          </h2>
          <p className="section-lead section-lead--center">
            Predictable, transparent, and low-drama. You always know where the
            project is, what's next, and how much it costs.
          </p>
        </div>

        <div className="process-grid">
          {steps.map((s, i) => (
            <div key={s.n} className="process-step">
              <div className="process-step-head">
                <span className="process-step-num">{s.n}</span>
                <div className="process-step-icon">{s.icon}</div>
              </div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              {i < steps.length - 1 && <div className="process-line" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
